import * as React from 'react';
import { Pressable, PressableProps } from 'react-native';

export interface OETouchableOpacityProps extends PressableProps {
  activeOpacity?: number;
}

export const OETouchableOpacity: React.FC<OETouchableOpacityProps> = ({
  style,
  children,
  activeOpacity = 0.5,
  ...rest
}) => {
  return (
    <Pressable
      {...rest}
      style={(props) => [
        { opacity: props.pressed ? activeOpacity : 1 },
        typeof style === 'function' ? style(props) : style,
      ]}
    >
      {children}
    </Pressable>
  );
};
